/**
 * Nationality → ISO 3166-1 alpha-2 code.
 *
 * Flags are served by flagcdn.com, which keys on the alpha-2 code, so the whole
 * job here is turning whatever an operator typed in the participants CSV into
 * that code. Full country list plus the aliases people actually use — IOC codes
 * ("INA", "MAS"), local names, and common abbreviations.
 *
 * Unknown values resolve to "un" (United Nations flag) rather than guessing from
 * the first two letters: that guess silently produced wrong flags, e.g.
 * "Portugal" → "po" (nonexistent) instead of "pt".
 */

const COUNTRY_TO_CODE = {
  "afghanistan": "af",
  "albania": "al",
  "algeria": "dz",
  "american samoa": "as",
  "andorra": "ad",
  "angola": "ao",
  "anguilla": "ai",
  "antarctica": "aq",
  "antigua and barbuda": "ag",
  "argentina": "ar",
  "armenia": "am",
  "aruba": "aw",
  "australia": "au",
  "austria": "at",
  "azerbaijan": "az",
  "bahamas": "bs",
  "bahrain": "bh",
  "bangladesh": "bd",
  "barbados": "bb",
  "belarus": "by",
  "belgium": "be",
  "belize": "bz",
  "benin": "bj",
  "bermuda": "bm",
  "bhutan": "bt",
  "bolivia": "bo",
  "bosnia and herzegovina": "ba",
  "botswana": "bw",
  "brazil": "br",
  "brunei": "bn",
  "bulgaria": "bg",
  "burkina faso": "bf",
  "burundi": "bi",
  "cambodia": "kh",
  "cameroon": "cm",
  "canada": "ca",
  "cape verde": "cv",
  "cayman islands": "ky",
  "central african republic": "cf",
  "chad": "td",
  "chile": "cl",
  "china": "cn",
  "colombia": "co",
  "comoros": "km",
  "congo": "cg",
  "cook islands": "ck",
  "costa rica": "cr",
  "croatia": "hr",
  "cuba": "cu",
  "curacao": "cw",
  "cyprus": "cy",
  "czechia": "cz",
  "dr congo": "cd",
  "denmark": "dk",
  "djibouti": "dj",
  "dominica": "dm",
  "dominican republic": "do",
  "ecuador": "ec",
  "egypt": "eg",
  "el salvador": "sv",
  "equatorial guinea": "gq",
  "eritrea": "er",
  "estonia": "ee",
  "eswatini": "sz",
  "ethiopia": "et",
  "fiji": "fj",
  "finland": "fi",
  "france": "fr",
  "french guiana": "gf",
  "french polynesia": "pf",
  "gabon": "ga",
  "gambia": "gm",
  "georgia": "ge",
  "germany": "de",
  "ghana": "gh",
  "gibraltar": "gi",
  "greece": "gr",
  "greenland": "gl",
  "grenada": "gd",
  "guadeloupe": "gp",
  "guam": "gu",
  "guatemala": "gt",
  "guernsey": "gg",
  "guinea": "gn",
  "guinea-bissau": "gw",
  "guyana": "gy",
  "haiti": "ht",
  "honduras": "hn",
  "hong kong": "hk",
  "hungary": "hu",
  "iceland": "is",
  "india": "in",
  "indonesia": "id",
  "iran": "ir",
  "iraq": "iq",
  "ireland": "ie",
  "isle of man": "im",
  "israel": "il",
  "italy": "it",
  "ivory coast": "ci",
  "jamaica": "jm",
  "japan": "jp",
  "jersey": "je",
  "jordan": "jo",
  "kazakhstan": "kz",
  "kenya": "ke",
  "kiribati": "ki",
  "kuwait": "kw",
  "kyrgyzstan": "kg",
  "laos": "la",
  "latvia": "lv",
  "lebanon": "lb",
  "lesotho": "ls",
  "liberia": "lr",
  "libya": "ly",
  "liechtenstein": "li",
  "lithuania": "lt",
  "luxembourg": "lu",
  "macao": "mo",
  "madagascar": "mg",
  "malawi": "mw",
  "malaysia": "my",
  "maldives": "mv",
  "mali": "ml",
  "malta": "mt",
  "marshall islands": "mh",
  "martinique": "mq",
  "mauritania": "mr",
  "mauritius": "mu",
  "mexico": "mx",
  "micronesia": "fm",
  "moldova": "md",
  "monaco": "mc",
  "mongolia": "mn",
  "montenegro": "me",
  "montserrat": "ms",
  "morocco": "ma",
  "mozambique": "mz",
  "myanmar": "mm",
  "namibia": "na",
  "nauru": "nr",
  "nepal": "np",
  "netherlands": "nl",
  "new caledonia": "nc",
  "new zealand": "nz",
  "nicaragua": "ni",
  "niger": "ne",
  "nigeria": "ng",
  "niue": "nu",
  "north korea": "kp",
  "north macedonia": "mk",
  "norway": "no",
  "oman": "om",
  "pakistan": "pk",
  "palau": "pw",
  "palestine": "ps",
  "panama": "pa",
  "papua new guinea": "pg",
  "paraguay": "py",
  "peru": "pe",
  "philippines": "ph",
  "poland": "pl",
  "portugal": "pt",
  "puerto rico": "pr",
  "qatar": "qa",
  "reunion": "re",
  "romania": "ro",
  "russia": "ru",
  "rwanda": "rw",
  "samoa": "ws",
  "san marino": "sm",
  "saudi arabia": "sa",
  "senegal": "sn",
  "serbia": "rs",
  "seychelles": "sc",
  "sierra leone": "sl",
  "singapore": "sg",
  "sint maarten": "sx",
  "slovakia": "sk",
  "slovenia": "si",
  "solomon islands": "sb",
  "somalia": "so",
  "south africa": "za",
  "south korea": "kr",
  "south sudan": "ss",
  "spain": "es",
  "sri lanka": "lk",
  "sudan": "sd",
  "suriname": "sr",
  "sweden": "se",
  "switzerland": "ch",
  "syria": "sy",
  "taiwan": "tw",
  "tajikistan": "tj",
  "tanzania": "tz",
  "thailand": "th",
  "timor-leste": "tl",
  "togo": "tg",
  "tonga": "to",
  "trinidad and tobago": "tt",
  "tunisia": "tn",
  "turkey": "tr",
  "turkmenistan": "tm",
  "tuvalu": "tv",
  "uganda": "ug",
  "ukraine": "ua",
  "united arab emirates": "ae",
  "united kingdom": "gb",
  "united states": "us",
  "uruguay": "uy",
  "uzbekistan": "uz",
  "vanuatu": "vu",
  "vatican city": "va",
  "venezuela": "ve",
  "vietnam": "vn",
  "yemen": "ye",
  "zambia": "zm",
  "zimbabwe": "zw",
  "åland islands": "ax",
};

/** Aliases: IOC codes, alternate spellings, and shorthand seen in entry lists. */
const ALIAS_TO_CODE = {
  "america": "us",
  "are": "ae",
  "arg": "ar",
  "aus": "au",
  "aut": "at",
  "aze": "az",
  "ban": "bd",
  "bel": "be",
  "bgd": "bd",
  "bra": "br",
  "brn": "bn",
  "bru": "bn",
  "burma": "mm",
  "cam": "kh",
  "can": "ca",
  "che": "ch",
  "chi": "cl",
  "chinese taipei": "tw",
  "chl": "cl",
  "chn": "cn",
  "col": "co",
  "cze": "cz",
  "czech republic": "cz",
  "den": "dk",
  "deu": "de",
  "deutschland": "de",
  "dnk": "dk",
  "east timor": "tl",
  "egy": "eg",
  "england": "gb",
  "esp": "es",
  "eth": "et",
  "fij": "fj",
  "fin": "fi",
  "fji": "fj",
  "fra": "fr",
  "gbr": "gb",
  "ger": "de",
  "great britain": "gb",
  "hkg": "hk",
  "holland": "nl",
  "idn": "id",
  "ina": "id",
  "ind": "in",
  "irn": "ir",
  "isr": "il",
  "ita": "it",
  "jpn": "jp",
  "kaz": "kz",
  "ken": "ke",
  "khm": "kh",
  "kor": "kr",
  "korea": "kr",
  "ksa": "sa",
  "kuw": "kw",
  "kwt": "kw",
  "lao": "la",
  "lka": "lk",
  "mac": "mo",
  "malaysia ": "my",
  "mar": "ma",
  "mas": "my",
  "mex": "mx",
  "mmr": "mm",
  "mys": "my",
  "ned": "nl",
  "nep": "np",
  "nga": "ng",
  "ngr": "ng",
  "nld": "nl",
  "nor": "no",
  "npl": "np",
  "nzl": "nz",
  "pak": "pk",
  "per": "pe",
  "phi": "ph",
  "phl": "ph",
  "png": "pg",
  "pol": "pl",
  "por": "pt",
  "prk": "kp",
  "prt": "pt",
  "qat": "qa",
  "republik indonesia": "id",
  "rsa": "za",
  "rus": "ru",
  "sau": "sa",
  "scotland": "gb",
  "sgp": "sg",
  "sin": "sg",
  "south korea": "kr",
  "spain ": "es",
  "sri": "lk",
  "sui": "ch",
  "swe": "se",
  "tha": "th",
  "timor leste": "tl",
  "tpe": "tw",
  "tuk": "tr",
  "tur": "tr",
  "uae": "ae",
  "uk": "gb",
  "ukr": "ua",
  "united states of america": "us",
  "usa": "us",
  "vie": "vn",
  "vnm": "vn",
  "wales": "gb",
};

/** Reverse map so a raw alpha-2 code in the CSV also resolves. */
const VALID_CODES = new Set(Object.values(COUNTRY_TO_CODE));

export const getFlagCode = (nationality) => {
  const raw = (nationality ?? "").toString().trim().toLowerCase();
  if (!raw || raw === "n/a" || raw === "-") return { code: "un", display: "UN" };

  const direct = COUNTRY_TO_CODE[raw] || ALIAS_TO_CODE[raw];
  if (direct) return { code: direct, display: direct.toUpperCase() };

  // Already an alpha-2 code (e.g. "ID" straight from the CSV).
  if (raw.length === 2 && VALID_CODES.has(raw)) {
    return { code: raw, display: raw.toUpperCase() };
  }

  return { code: "un", display: "UN" };
};

export default getFlagCode;
